// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__lhs_u","text":"styles_text__dF1bk","chevron":"styles_chevron__ALMGw","skeleton-animation":"styles_skeleton-animation__uZNaE"};